import '@polymer/polymer/polymer-legacy.js';
import { SnapLocationToConnectionPath } from '../../modules/SnapLocationToConnectionPath.js';
import '@polymer/iron-localstorage/iron-localstorage.js';
import './time-buckets.js';
import { DataLayer } from '../../modules/DataLayer/DataLayer.js';
import { Polymer } from '@polymer/polymer/lib/legacy/polymer-fn.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
import { SquashNulls } from '../../modules/SquashNulls.js';
import { PickAnAttribute } from '../../modules/PickAnAttribute.js';
import { Path } from '../../modules/Path.js';
import { GetMainPhoto } from '../../modules/GetMainPhoto.js';
Polymer({
  _template: html`
    <time-buckets id="timeBuckets" user-group="{{userGroup}}" uid="{{uid}}" jobid="{{jobid}}" job-styles="[[jobStyles]]"></time-buckets>
    <iron-localstorage name="time-bucket-start" value="{{timeBucketStart}}"></iron-localstorage>
  `,

  /*
    fires toast, prompt, cancel-prompt, secondary-prompt, cancel-secondary-prompt zoom-to-active
  */
  is: 'job-time-collection',

  properties: {
    activeItem: {
      type: String,
      notify: true
    },
    activeItem: {
      type: String,
      notify: true
    },
    activeCommand: {
      type: String,
      notify: true
    },
    activeTool: {
      type: String,
      notify: true
    },
    checklistAutoZoom: {
      type: Boolean
    },
    connections: {
      type: Object
    },
    collectionOrderLogic: {
      type: Object
    },
    color: {
      type: String,
      value: '#FF8300'
    },
    gotTimeSync: {
      type: Boolean,
      value: false
    },
    lastConnection: {
      type: String,
      value: ''
    },
    modelDefaults: {
      type: Object,
      value: {}
    },
    timeBucketLog: {
      type: Array,
      value: function () {
        return [];
      }
    },
    skipList: {
      type: Array,
      value: function () {
        return [];
      }
    },
    sweepLists: {
      type: Array,
      value: function () {
        return [];
      }
    },
    signedIn: Boolean,
    icon: {
      type: String,
      value: 'check'
    },
    jobid: {
      type: String,
      observer: 'jobidChanged'
    },
    jobName: String,
    nodes: {
      type: Object
    },
    nodesAreLoaded: {
      type: Boolean,
      observer: 'nodesAreLoadedChanged'
    },
    teamMembers: Object,
    uid: String,
    userGroup: String,
    promptButtonDisbled: {
      type: Boolean,
      notify: true
    }
  },

  prompts: {
    doneCollection: { text: 'Mark Done', cancelSecondary: true },
    tookAdditionalPhotos: { text: 'Took More Photos', cancelSecondary: true },
    doneMidpoint: { text: 'Done (Midpoint)', icon: 'katapult-map:triangle-up', color: '#0055ff' },
    secondaryActionAddSection: { text: 'Done', icon: 'katapult-map:triangle-up', color: '#00aaff' }
  },

  init: function () {
    this.activeTool = 'jobTimeCollection';
    this.map_pan();
  },

  prompt: function () {
    this.fire('prompt', this.prompts[this.activeCommand]);
  },

  getByKey: function (type, id, attribute) {
    return this.domHost.getByKey(type, id, attribute);
  },

  nodesAreLoadedChanged: function () {
    if (this.zoomWhenLoaded) {
      this.async(function () {
        this.zoomToClosest();
      }, 50);
      this.zoomWhenLoaded = false;
    }
  },

  jobidChanged: function () {
    this.timeBucketLog = [];
    this.skipList = [];
    this.firstSkippedItem = null;
  },

  timeSyncClosed: function () {
    if (this.timeBucketStart == null || this.timeBucketStart.jobid != this.jobid) {
      this.setStartTime();
    }
  },

  setStartTime: function (time) {
    time = time || new Date().getTime();
    this.set('timeBucketStart', { startTime: time, jobid: this.jobid });
  },

  tookAdditionalPhotos: function (nothing, lat, lng, detail, stopTime) {
    // This function only exists so that we can give a more detailed prompt. It actually does the same thing as this.doneCollection
    this.doneCollection(true, lat, lng, detail, stopTime);
  },

  checkIfLastTimeBucket: function () {
    if (this.timeBucketLog.length == 0) {
      this.fire('toast', 'No more time buckets to undo.');
    } else if (this.timeBucketLog[0].jobid != this.jobid) {
      this.fire('toast', 'Cannot undo timebuckets after leaving a job.');
    } else {
      return true;
    }
  },

  undoLastTimeBucket: async function () {
    if (this.checkIfLastTimeBucket) {
      const { GeofireTools } = await import('../../modules/GeofireTools.js');
      let update = {};
      let lastTimeBucket = this.timeBucketLog.shift();
      let itemData = this.getByKey('', lastTimeBucket.item);
      let keys = lastTimeBucket.item.slice(1).split(':');
      let attributeKey = lastTimeBucket.item[0] == 'n' ? 'attributes' : 'multi_attributes';
      let itemPath =
        lastTimeBucket.item[0] == 'n' ? `nodes/${keys[0]}/attributes` : `connections/${keys[0]}/sections/${keys[1]}/multi_attributes`;
      delete itemData[attributeKey].time_bucket[lastTimeBucket.itemKey];
      update[itemPath + '/time_bucket/' + lastTimeBucket.itemKey] = null;
      if (!lastTimeBucket.alreadyFieldComplete) {
        delete itemData[attributeKey].field_completed;
        update[itemPath + '/field_completed/'] = null;
      }
      GeofireTools.setGeohash(lastTimeBucket.item[0] == 'n' ? 'nodes' : 'sections', itemData, keys[0], this.jobStyles, update, {
        sectionId: keys[1]
      });
      await FirebaseWorker.ref('photoheight/jobs/' + this.jobid).update(update);
      this.set('timeBucketStart', { startTime: lastTimeBucket.startTime, jobid: this.jobid });
      this.fire('toast', 'Last Time Bucket Removed');
    }
  },

  doneCollection: function (isAdditional, lat, lng, detail, stopTime, update, assessmentDetail) {
    if (!this.gotTimeSync) {
      this.domHost.$.timeSync.open();
      return;
    }
    this.doneFeedback();
    this.skipList = [];
    this.firstSkippedItem = null;
    var item = this.getByKey('', this.activeItem);
    var alreadyFieldComplete = !!PickAnAttribute(item.attributes || item.multi_attributes, 'field_completed');
    var itemKey = this.$.timeBuckets.stop(
      this.jobid,
      this.activeItem,
      this.uid,
      this.userGroup,
      this.teamMembers,
      this.timeBucketStart.startTime,
      stopTime,
      item,
      update,
      assessmentDetail,
      function (itemId, showPulse) {
        if (showPulse) {
          this.fire('pulse-item', itemId);
        }
        this.fire('item-done', itemId);
        // Fire show-collection-progress if item completed is a node
        if (itemId && itemId[0] == 'n') {
          this.fire('show-collection-progress');
        }
      }.bind(this, this.activeItem, isAdditional === true)
    );
    this.timeBucketLog.unshift({
      startTime: this.timeBucketStart.startTime,
      jobid: this.jobid,
      item: this.activeItem,
      itemKey,
      alreadyFieldComplete
    });
    if (this.timeBucketLog.length > 30) this.timeBucketLog.pop();
    this.setStartTime(stopTime);
    if (!assessmentDetail?.drawJoin) {
      this.activeCommand = 'tookAdditionalPhotos';
      this.prompt();
      if (
        this.activeItem[0] == 'n' &&
        this.checklistAutoZoom &&
        (SquashNulls(loadRenderMap.pointLocations[this.activeItem.slice(1)], 'data', 'n') == '' || this.autoZoomSkipMidspans)
      ) {
        this.fire('secondary-prompt', { text: 'Skip' });
      }
      // If done collection was NOT called in the middle of an assessment
      if (!Path.get(assessmentDetail, 'noAutoZoom')) this.zoomToNext();
    }
  },

  doneFeedback: function () {
    if (this.soundAndVibrate) {
      if (window.navigator.vibrate) window.navigator.vibrate([100]);
      new Audio('../_resources/sounds/pop-sound.mp3').play();
    }
    this.promptButtonDisbled = true;
    setTimeout(() => {
      this.promptButtonDisbled = false;
    }, 500);
  },

  addSection: function (closest, lat, long) {
    if (!this.gotTimeSync) {
      this.domHost.$.timeSync.open();
      return;
    }
    // Stop with a message if the connection or either of its end nodes isn't loaded
    const connId = closest?.item?.slice(1);
    const connection = this.connections?.[connId];
    const node1 = this.nodes?.[connection?.node_id_1];
    const node2 = this.nodes?.[connection?.node_id_2];
    if (!node1 || !node2) {
      this.fire('toast', 'Could not add a section because this connection or its end nodes are not loaded.');
      return;
    }
    this.doneFeedback();

    // Place the section at the closest point along the connection's whole path
    const connectionPathPoints = [[node1.latitude, node1.longitude], ...(connection.breakpoints ?? []), [node2.latitude, node2.longitude]];
    const pointOnLine = SnapLocationToConnectionPath(lat, long, connectionPathPoints);
    this.createSection(
      connId,
      pointOnLine.latitude,
      pointOnLine.longitude,
      false,
      function (sectionKey) {
        if (this.doesConnectionHaveMidspanSection(connId)) {
          this.focusSection(sectionKey, connId);
        }
      }.bind(this)
    );
    if (this.doesConnectionHaveMidspanSection(connId)) {
      this.activeCommand = 'tookAdditionalPhotos';
      this.prompt();
      this.zoomToNext();
    } else {
      this.fire('cancel-secondary-prompt');
    }
  },

  createSection: function (connectionId, lat, long, isMidpoint, callback) {
    var ref = FirebaseWorker.ref('photoheight/jobs/' + this.jobid);

    var update = {};
    let attributes = [];
    // Add field completed
    attributes.push({
      attribute: 'field_completed',
      key: 'value',
      value: true
    });

    // Add time bucket
    var timeBucketKey = ref.push().key;
    var stopTime = new Date().getTime();
    attributes.push({
      attribute: 'time_bucket',
      key: timeBucketKey,
      value: {
        start: this.timeBucketStart.startTime,
        stop: stopTime,
        uid: this.uid,
        teamMembers: this.teamMembers
      }
    });

    // Get additional section attributes from the model
    var sectionAttributes = SquashNulls(this.modelConfig, 'section_attributes');
    for (var key in sectionAttributes) {
      attributes.push({
        attribute: key,
        key: 'button_added',
        value: sectionAttributes[key]
      });
    }

    // Get the key for the new section
    if (isMidpoint) {
      var sectionKey = 'midpoint_section';
    } else {
      var sectionKey = ref.push().key;
    }

    // Create the section
    DataLayer.Sections.create(connectionId, this.connections[connectionId], lat, long, this.otherAttributes, FirebaseWorker, {
      update,
      method: 'mobile',
      key: sectionKey,
      attributes,
      jobStyles: this.jobStyles
    });

    // Run the update
    ref.update(update, callback(sectionKey));

    this.timeBucketLog.unshift({
      startTime: this.timeBucketStart.startTime,
      jobid: this.jobid,
      item: 's' + connectionId + ':' + sectionKey,
      itemKey: timeBucketKey,
      alreadyFieldComplete: false
    });
    if (this.timeBucketLog.length > 30) this.timeBucketLog.pop();
    this.setStartTime(stopTime);
    this.async(function () {
      this.fire('item-done', 's' + connectionId + ':' + sectionKey);
    });
  },

  change: function (closest) {
    let existingPhoto = null;
    if (closest == null) {
      this.activeCommand = '';
      this.fire('secondary-prompt', { text: 'Please select closer to an item.', cancelMain: true });
      this.activeItem = '';
    } else {
      if (closest.item[0] === 'c') {
        var connId = closest.item.slice(1);
        this.activeItem = 'c' + connId;
        this.fire('secondary-prompt', this.prompts.secondaryActionAddSection);
        this.activeCommand = 'doneMidpoint';
        if (this.doesConnectionHaveMidspanSection(connId)) {
          this.fire('cancel-prompt');
        } else {
          this.prompt();
        }
      } else {
        this.activeItem = closest.item;
        if (closest.item[0] === 'n') {
          var nodeId = closest.item.slice(1);
          if (this.isNodeDone(this.nodes[nodeId].attributes)) {
            this.activeCommand = 'tookAdditionalPhotos';
          } else {
            this.activeCommand = 'doneCollection';
          }
        } else if (closest.item[0] === 's') {
          var splitItem = closest.item.split(':');
          var connId = splitItem[0].slice(1);
          var sectId = splitItem[1];
          var sectAttributes = this.connections[connId].sections[sectId].multi_attributes;
          if (this.isSectionDone(sectAttributes)) {
            this.activeCommand = 'tookAdditionalPhotos';
          } else {
            this.activeCommand = 'doneCollection';
          }
        }
        this.prompt();
        if (
          this.activeItem[0] == 'n' &&
          this.checklistAutoZoom &&
          (SquashNulls(loadRenderMap.pointLocations[this.activeItem.slice(1)], 'data', 'n') == '' || this.autoZoomSkipMidspans)
        ) {
          this.fire('secondary-prompt', { text: 'Skip' });
        }
        existingPhoto = GetMainPhoto(this.getByKey('', this.activeItem)?.photos);
      }
    }
    this.existingPhoto = existingPhoto;
    if (existingPhoto) {
      this.fire('tertiary-prompt', { text: 'View Main Photo', buttonColor: '#007299' });
    } else {
      this.fire('cancel-tertiary-prompt');
    }
  },

  doesConnectionHaveMidspanSection: function (connId) {
    if (this.connections[connId].sections && this.connections[connId].sections.midpoint_section) {
      return true;
    }
    return false;
  },

  doneMidpoint: function (closest, lat, long) {
    this.doneFeedback();
    // If just added a section, closest could be a section
    var connId = null;
    if (closest.item[0] == 's') {
      connId = closest.item.slice(1).split(':')[0];
    } else {
      connId = closest.item.slice(1);
    }
    var stopTime = new Date().getTime();
    if (this.connections[connId]) {
      if (this.connections[connId].sections?.midpoint_section) {
        // update[connId+'sections/midpoint_section/'+multi_attributes]
        var midpointItem = 's' + connId + ':midpoint_section';
        var alreadyFieldComplete = !!PickAnAttribute(
          this.connections[connId].sections.midpoint_section.multi_attributes,
          'field_completed'
        );
        var itemKey = this.$.timeBuckets.stop(
          this.jobid,
          midpointItem,
          this.uid,
          this.userGroup,
          this.teamMembers,
          this.timeBucketStart.startTime,
          stopTime,
          this.connections[connId].sections.midpoint_section,
          null,
          null,
          function () {
            // this.fire('toast', "Done!");
          }.bind(this)
        );
        this.timeBucketLog.unshift({
          startTime: this.timeBucketStart.startTime,
          jobid: this.jobid,
          item: midpointItem,
          itemKey,
          alreadyFieldComplete
        });
        if (this.timeBucketLog.length > 30) this.timeBucketLog.pop();
        this.setStartTime(stopTime);
      } else if (this.connections[connId].sections == null || this.connections[connId].sections?.midpoint_section == null) {
        var tbkey = FirebaseWorker.ref().push().key;
        var attributes = {
          field_completed: { value: true },
          time_bucket: {}
        };
        attributes.time_bucket[tbkey] = {
          start: this.timeBucketStart.startTime,
          stop: stopTime,
          uid: this.uid,
          teamMembers: this.teamMembers
        };
        this.createMidpointSection(connId, attributes);
        this.timeBucketLog.unshift(
          (this.lastTimeBucket = {
            startTime: this.timeBucketStart.startTime,
            jobid: this.jobid,
            item: 's' + connId + ':midpoint_section',
            itemKey: tbkey,
            alreadyFieldComplete: false
          })
        );
        if (this.timeBucketLog.length > 30) this.timeBucketLog.pop();
        this.setStartTime(stopTime);
        this.activeCommand = 'doneMidpoint';
        this.fire('secondary-prompt', this.prompts.secondaryActionAddSection);
        this.fire('cancel-prompt');
        this.zoomToNext();
      }
    } else {
      throw new Error(`No connection found. connId: ${connId}, jobId: ${this.jobid}`);
    }
  },

  map_pan: function (latitude, longitude) {
    this.change(
      this.domHost.findClosest(null, null, {
        absoluteClosest: false,
        skipNonCollectTypes: true
      })
    );
  },

  action_secondary: function (closest, latitude, longitude) {
    if (this.activeCommand == 'doneMidpoint') {
      this.addSection(closest, latitude, longitude);
    }
    //Skip
    else {
      if (!this.firstSkippedItem) this.firstSkippedItem = { latitude, longitude };
      this.skipList.push(this.activeItem);
      this.zoomToNext();
    }
  },

  action_tertiary: function () {
    if (this.existingPhoto) {
      this.dispatchEvent(new CustomEvent('open-photo', { detail: { photoId: this.existingPhoto } }));
    }
  },

  focusSection: function (sectionId, connId) {
    this.async(function () {
      if (this.activeItem == 'c' + connId) {
        this.activeItem = 's' + connId + ':' + sectionId;
      }
    }, 16);
  },

  createMidpointSection: function (connId, attributes) {
    var connectionData = this.connections[connId];
    var n1 = this.nodes[connectionData.node_id_1];
    var n2 = this.nodes[connectionData.node_id_2];
    var mid = this.domHost.getMidpointLatLng(
      new google.maps.LatLng(n1.latitude, n1.longitude),
      new google.maps.LatLng(n2.latitude, n2.longitude)
    );

    let attributesArray = [];
    // Create an array form of the attributes object provided
    for (let attributeName in attributes) {
      for (let attributeKey in attributes[attributeName]) {
        attributesArray.push({
          attribute: attributeName,
          key: attributeKey,
          value: attributes[attributeName][attributeKey]
        });
      }
    }
    // Get additional section attributes from the model
    var sectionAttributes = SquashNulls(this.modelConfig, 'section_attributes');
    for (let key in sectionAttributes) {
      attributesArray.push({
        attribute: key,
        key: 'button_added',
        value: sectionAttributes[key]
      });
    }

    let update = {};
    // Create the section
    DataLayer.Sections.create(connId, connectionData, mid.lat(), mid.lng(), this.otherAttributes, FirebaseWorker, {
      update,
      method: 'mobile',
      key: 'midpoint_section',
      attributes: attributesArray,
      jobStyles: this.jobStyles
    });

    FirebaseWorker.ref('photoheight/jobs/' + this.jobid).update(
      update,
      function (error) {
        if (error) {
          this.fire('toast', error);
        } else {
          this.fire('item-done', 's' + connId + ':midpoint_section');
        }
      }.bind(this)
    );
  },

  zoomToNext: function () {
    if (this.checklistAutoZoom) {
      if (this.activeItem[0] == 'n') {
        var foundOne = false;
        var nodeId = this.activeItem.slice(1);
        var conns = SquashNulls(loadRenderMap.pointLocations[nodeId], 'data', 'n');
        if (conns != '' && !this.autoZoomSkipMidspans) {
          var connList = [];
          for (var connId in conns) {
            var conn = this.connections[connId];
            var node1 = this.nodes[nodeId];
            var node2 = this.nodes[nodeId == conn.node_id_1 ? conn.node_id_2 : conn.node_id_1];
            connList.push({
              connId,
              conn,
              bearing:
                google.maps.geometry.spherical.computeHeading(
                  new google.maps.LatLng(node1.latitude, node1.longitude),
                  new google.maps.LatLng(node2.latitude, node2.longitude)
                ) + 360
            });
          }
          connList.sort(function (a, b) {
            return a.bearing - b.bearing;
          });
          for (var i = 0; i < connList.length; i++) {
            if (!this.isConnDone(connList[i].conn)) {
              foundOne = true;
              this.activeItem = 'c' + connList[i].connId;
              this.fire('zoom-to-active');
              this.map_pan();
              break;
            }
          }
        }
        if (!foundOne) {
          this.zoomToClosest(true, this.domHost.latitude, this.domHost.longitude);
        }
      } else if (this.activeItem[0] == 'c' || this.activeItem[0] == 's') {
        var conn;
        if (this.activeItem[0] == 'c') {
          conn = this.connections[this.activeItem.slice(1)];
        } else {
          var ids = this.activeItem.slice(1).split(':');
          conn = this.connections[ids[0]];
        }
        var n1 = this.nodes[conn.node_id_1];
        if (!this.isNodeDone(n1.attributes)) {
          this.activeItem = 'n' + conn.node_id_1;
          this.fire('zoom-to-active');
          this.map_pan();
        } else {
          var n2 = this.nodes[conn.node_id_2];
          if (!this.isNodeDone(n2.attributes)) {
            this.activeItem = 'n' + conn.node_id_2;
            this.fire('zoom-to-active');
            this.map_pan();
          } else {
            this.zoomToClosest(true, this.domHost.latitude, this.domHost.longitude);
          }
        }
      }
    }
  },

  zoomToClosest: function (skipMatch, latitude, longitude) {
    let lat = latitude || this.gpsData.latitude;
    let lng = longitude || this.gpsData.longitude;
    if (this.firstSkippedItem) {
      lat = this.firstSkippedItem.latitude;
      lng = this.firstSkippedItem.longitude;
    }
    var closest;
    if (this.autoZoomSkipMidspans) {
      closest = this.domHost.closestNode(lat, lng, {
        skipNonCollectTypes: true,
        skipGPSMatch: skipMatch,
        skipDoneItems: true,
        skipList: this.skipList
      });
      if (closest.distance == Infinity) closest = null;
    } else {
      closest = this.domHost.findClosest(lat, lng, {
        absoluteClosest: true,
        skipNonCollectTypes: true,
        skipGPSMatch: skipMatch,
        skipDoneItems: true,
        skipList: this.skipList
      });
    }
    if (closest == null && this.skipList.length > 0) {
      this.skipList = [];
      this.fire('toast', 'All remaining items skipped. Skip List Reset.');
      this.zoomToClosest(skipMatch, latitude, longitude);
      return;
    }
    if (closest != null && this.activeItem != closest.item) {
      this.activeItem = closest.item;
      this.fire('zoom-to-active');
      this.change(closest);
    }
  },

  isConnDone: function (connection, collectionOrderLogic) {
    if (connection == null) return false;
    var collectionOrderLogic = collectionOrderLogic || this.collectionOrderLogic;
    if (!collectionOrderLogic) return false;
    var attributes = connection.attributes;
    var type = PickAnAttribute(attributes, this.modelDefaults.connection_type_attribute);
    if (collectionOrderLogic.connection_types_to_skip.indexOf(type) != -1) {
      return true;
    } else if (connection.sections == null) {
      return false;
    } else {
      for (var sectionId in connection.sections) {
        var gotOne = false;
        if (
          connection.sections[sectionId].multi_attributes != null &&
          connection.sections[sectionId].multi_attributes.field_completed != null &&
          PickAnAttribute(connection.sections[sectionId].multi_attributes, 'field_completed') === true
        ) {
          var time_bucket = connection.sections[sectionId].multi_attributes.time_bucket;
          for (var itemKey in time_bucket) {
            // && time_bucket[itemKey].stop - time_bucket[itemKey].start > 1000
            if (time_bucket[itemKey].notDone == null && time_bucket[itemKey].start != null && time_bucket[itemKey].stop != null) {
              gotOne = true;
            }
          }
        }
        if (!gotOne) {
          return false;
        }
      }
      return true;
    }
  },

  isNodeDone: function (attributes, collectionOrderLogic) {
    var collectionOrderLogic = collectionOrderLogic || this.collectionOrderLogic;
    if (!collectionOrderLogic) return false;
    var nodeType = PickAnAttribute(attributes, this.modelDefaults.node_type_attribute);

    if (
      collectionOrderLogic &&
      ((collectionOrderLogic.node_types_to_skip && collectionOrderLogic.node_types_to_skip.indexOf(nodeType) != -1) ||
        (collectionOrderLogic.autoZoom_node_types_to_skip && collectionOrderLogic.autoZoom_node_types_to_skip.indexOf(nodeType) != -1))
    ) {
      return true;
    }
    if (attributes != null && attributes.field_completed != null && PickAnAttribute(attributes, 'field_completed') === true) {
      return true;
    }
    return false;
  },

  isSectionDone: function (attributes) {
    if (
      attributes != null &&
      attributes.field_completed != null &&
      attributes.field_completed != null &&
      PickAnAttribute(attributes, 'field_completed') == true
    ) {
      return true;
    }
    return false;
  }
});
